// Display amounts with 2 decimal places, e.g. 550 -> "$5.50", without dropping trailing zeros as plain toLocaleString() does.
// Always en-US separators ("$1,234.50"), not the browser's locale -- a Spanish-locale browser would
// otherwise show "$1.234,50" next to symbols and amounts written the en-US way everywhere else.
// For Stripe zero-decimal currencies (JPY, KRW, VND, etc.), pass isZeroDecimal since the amount is already in the currency's base unit and should not be divided by 100 (e.g. 550 -> "¥550", not "¥5.50").
// stripWholeCents: English-sentence amounts drop ".00" ("$650 a year") while keeping real cents ("$54.17").

export function formatCurrencyAmount(amount, symbol = '$', isZeroDecimal = false, { stripWholeCents = false } = {}) {
  // Callers round to integer cents; rounding here keeps `cents % 100` well-defined if a float slips through.
  const cents = Math.round(Number(amount))
  if (isZeroDecimal) return `${symbol}${cents.toLocaleString("en-US")}`

  const whole = stripWholeCents && cents % 100 === 0
  return `${symbol}${(cents / 100).toLocaleString("en-US", {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2
  })}`
}
